import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { apiLongRunningRequestTimeoutMs } from "../config";
import {
  IAiTitleStageResponse,
  IListingOptimisationPartsRequest,
} from "../models/listingOptimisation/IListingReview";

/**
 * The AI title builder over a selection. The API generates a title per part and stages each one
 * as the listing's new title when it differs from the live title; titles over 80 characters or
 * with warnings come back unstaged with the reason. The live eBay title is untouched until relist.
 */
export default function usePartAiTitleBulk(componentName = "usePartAiTitleBulk") {
  // One AI call per part, in chunks - well past the default JSON timeout for a big selection.
  const { post } = useApiHelper({
    ...apiConfig(componentName),
    timeoutMs: apiLongRunningRequestTimeoutMs,
  });
  const queryClient = useQueryClient();

  const generateAiTitles = useMutation(
    (partDataIds: string[]) =>
      post<IListingOptimisationPartsRequest, IAiTitleStageResponse>("/listingoptimisation/ai-titles", {
        partDataIds,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["listingOptimisations"]);
      },
    }
  );

  return {
    generateAiTitles,
  };
}
